import React from "react";
import { NewsletterIcon } from "./Icon";

const LaunchpadBanner = () => {
	const handleSubmit = (e) => {
		e.preventDefault();
	};
	return (
		<section
			className="banner-section banner-section-2"
			style={{
				background: `url('/img/banner-bg.png') no-repeat center center / cover`,
			}}
		>
			<div className="container">
				<div className="banner-wrapper">
					<div className="banner-content">
						<h1 className="title pb-2">
							<div className="text-gradient me-2">Explore</div>
							the features of our Presale
						</h1>
						<form
							onSubmit={handleSubmit}
							className="newsletter-form ms-0"
							style={{
								maxWidth: "480px",
							}}
						>
							<input
								type="text"
								className="form-control"
								placeholder="Search by Presale"
							/>
							<button type="submit" className="no-gutter">
								<NewsletterIcon />
							</button>
						</form>
					</div>
					<BannerImage className="d-xl-none" />
				</div>
			</div>
			<BannerImage className="d-none d-xl-block" />
		</section>
	);
};

const BannerImage = ({ className }) => (
	<div className={`banner-thumb-2 ${className}`}>
		<img src="/img/logo3.png" alt=""  width={500}/>
	</div>
);

export default LaunchpadBanner;
